import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../../styles/Auth/sidebar.css';
import ResetPasswordPage from '../../pages/Auth/Reset-Password/reset-password.jsx';
import { toast } from 'react-toastify';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openSubmenus, setOpenSubmenus] = useState({});
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const toggleSubmenu = (label) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const confirmLogout = () => {
    sessionStorage.clear();
    toast.success('Logout successful!');
    navigate('/login');
  };
  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: <FontAwesomeIcon icon={["fas", "store-alt"]} size="lg" /> },
    { path: '/products', label: 'Products', icon: <FontAwesomeIcon icon={["fas", "cube"]} size="lg" /> },
    { path: '/banner', label: 'Banners', icon: <FontAwesomeIcon icon={["fas", "cube"]} size="lg" /> },
    { path: '/category', label: 'Category', icon: <FontAwesomeIcon icon={["fas", "folder-open"]} size="lg" /> },
    { path: '/sub-category', label: 'Sub Category', icon: <FontAwesomeIcon icon={["fas", "copy"]} size="lg" /> },
    { path: '/attributes', label: "Attributes", icon: <FontAwesomeIcon icon={["fas", "sliders-h"]} size="lg" /> },
    { path: '/combooffers', label: "Combo Offer", icon: <FontAwesomeIcon icon={["fas", "gifts"]} size="lg" /> },
    // { path: '/services', label: 'Services', icon: <Icon icon="mdi:tag-outline" width="20" height="20" /> },
    { path: '/purchases', label: 'Purchase', icon: <FontAwesomeIcon icon={["fas", "shopping-basket"]} size="lg" /> },
    // { path: '/purchaseinvoice', label: 'Purchase Invoice', icon: <FontAwesomeIcon icon={["fas", "money-check-alt"]} size="lg" /> },
    // {
    //   path: '/purchasereturn', label: 'Purchase Return', icon: <FontAwesomeIcon icon={["fas", "money-check"]} size="lg" />
    // },
    {
      path: '/stocks', label: 'Stocks', icon: <FontAwesomeIcon icon={["fas", "boxes"]} size="lg" />
    },
    // {
    //   path: '/stockexchange', label: 'Stocks Exchange', icon: <FontAwesomeIcon icon={["fas", "exchange-alt"]} size="lg" />
    // },
    {
      path: '/orders', label: 'Online Orders', icon: <FontAwesomeIcon icon={["fas", "boxes"]} size="lg" />
    },
    { path: '/customers', label: 'Customers', icon: <FontAwesomeIcon icon={["fas", "user-tag"]} size="lg" /> },
    { path: '/sales', label: 'Sales', icon: <FontAwesomeIcon icon={["fas", "chart-line"]} size="lg" /> },
    // { path: '/sales-return', label: 'Sales Return', icon: <FontAwesomeIcon icon={["fas", "share-square"]} size="lg" /> },
    { path: '/expense', label: 'Expense', icon: <FontAwesomeIcon icon={["fas", "donate"]} size="lg" /> },
    { path: '/employees', label: 'Employees', icon: <FontAwesomeIcon icon={["fas", "house-user"]} size="lg" /> },
    { path: '/reports', label: 'Reports', icon: <FontAwesomeIcon icon={["fas", "file-medical-alt"]} size="lg" /> },
    // {
    //   path: '/coupons', label: 'Coupons', icon: <FontAwesomeIcon icon={["fas", "user-shield"]} size="lg" />
    // },
    {
      path: '/suppliers', label: 'Suppliers', icon: <FontAwesomeIcon icon={["fas", "user-shield"]} size="lg" />
    },
    {
      path: '/campaigns', label: 'Campaign', icon: <FontAwesomeIcon icon={["fas", "campground"]} size="lg" />,
      subItems: [
        { path: '/campaign/history', label: 'CampaignHistory', icon: <FontAwesomeIcon icon={["fas", "history"]} size="lg" /> }
      ]
    },
    // { path: '/settings', label: 'Settings', icon: <Icon icon="mdi:settings-outline" width="20" height="20" /> },
    { label: 'Logout', icon: <FontAwesomeIcon icon={["fas", "sign-out-alt"]} size="lg" />, onClick: () => setShowLogoutModal(true) },
  ];

  return (
    <div className="sidebar-container">
      <div className="sidebar-logo">
        <img src="/assets/mayura.png" alt="Logo" />
      </div>

      <aside className="sidebar">
        <ul className="sidebar-nav">
          {navItems.map(({ path, label, icon, subItems, onClick }) => (
            <li key={label} className={path && location.pathname.startsWith(path) ? 'active' : ''}>

              <div
                className="sidebar-link"
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                onClick={() => {
                  if (subItems) {
                    toggleSubmenu(label);
                  } else if (onClick) {
                    onClick();
                  }
                }}
              >
                {/* Always wrap left part in Link */}
                {path ? (
                  <Link
                    to={path}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      textDecoration: 'none',
                      color: 'inherit',
                      flex: 1
                    }}
                  >
                    <span className="icon">{icon}</span>
                    <span className="link-text">{label}</span>
                  </Link>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      cursor: onClick ? 'pointer' : 'default',
                      flex: 1
                    }}
                  >
                    <span className="icon">{icon}</span>
                    <span className="link-text">{label}</span>
                  </div>
                )}

                {/* Right caret → works as toggle if submenu exists */}
                {/* {subItems ? (
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleSubmenu(label);
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    {openSubmenus[label] ? <FaCaretDown /> : <FaCaretRight />}
                  </div>
                ) : (
                  path && <FaCaretRight /> // still aligned, only for links
                )} */}
              </div>

              {/* Submenu rendering */}
              {subItems && openSubmenus[label] && (
                <ul className="submenu">
                  {subItems.map((sub) => (
                    <li key={sub.path}>
                      <Link
                        to={sub.path}
                        className={`submenu-link ${location.pathname === sub.path ? 'active-sub' : ''}`}
                      >
                        <span className="icon">{sub.icon}</span>
                        <span>{sub.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </aside>
      {/* Logout Modal */}
      {showLogoutModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <button className="modal-close" onClick={() => setShowLogoutModal(false)}>
              &times;
            </button>
            <h3>Confirm Logout!</h3>
            <p>Are you sure you want to log out?</p>
            <div className="modal-buttons">
              <button className="modal-btn confirm" onClick={confirmLogout}>Yes</button>
              <button className="modal-btn cancel" onClick={() => setShowLogoutModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Reset Password */}
      {showResetModal && (
        <ResetPasswordPage onClose={() => setShowResetModal(false)} />
      )}

    </div>

  );
};

export default Sidebar;
